import type { ComputedRef } from 'vue'
import type { ActionMethod, Store } from 'vuex'
import { computed } from 'vue'

export function mapGetters<ComputedType = any>(
  store: Store<any>,
  namespace: string,
  map: Record<string, string>,
): Record<string, ComputedRef<ComputedType>> {
  return Object.entries(map).reduce((result: Record<string, ComputedRef>, [key, value]) => {
    return {
      ...result,
      [key]: computed<ComputedType>(() => store.getters[`${namespace}/${value}`]),
    }
  }, {})
}

export function mapActions(
  store: Store<any>,
  namespace: string,
  map: Record<string, string>,
): Record<string, ActionMethod> {
  return Object.entries(map).reduce((result: Record<string, ActionMethod>, [key, value]) => {
    return {
      ...result,
      [key]: (...args: Array<unknown>) => store.dispatch(`${namespace}/${value}`, ...args),
    }
  }, {})
}
